import { useQuery } from "@tanstack/react-query";
import { apiListBouncers } from "@/api/client.js";

export const bouncersQueryKey = ["bouncers"] as const;

export function useBouncersQuery() {
  return useQuery({
    queryKey: bouncersQueryKey,
    queryFn: apiListBouncers,
    staleTime: 60_000,
  });
}
